"use client";
import { Drawer, Button, FormProps, Flex } from "@basic-components";
import { ReactNode, useEffect } from "react";
import * as yup from "yup";
import { useFormContext } from "react-hook-form";
import { FormProps as FormPropsType } from '@general-components/Form/types';
import { Form } from '@general-components';

const ActionButtonSubmit = ({
  onClick,
}: {
  onClick: (values: any) => void;
}) => {
  const { handleSubmit, formState: { isSubmitting, errors } } = useFormContext();

  // 【调试关键】控制台打印所有校验错误，直接找到隐藏字段
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
    }
  }, [errors]);

  const handleOk = async (values: any) => {
    try {
      await onClick(values);
    } catch (err) {
      console.error("提交失败：", err);
    }
  };

  return (
    <Button
      onClick={handleSubmit(handleOk)}
      type="primary"
      loading={isSubmitting}
      disabled={isSubmitting}
    >
      确定
    </Button>
  );
};

export const DrawerForm = ({
 visible,
 size = 500,
 onCancel,
 onOk,
 schema,
 children,
 title,
 defaultValues,
 form,
 isView = false,
 onChange,
 ...formProps
}: {
  visible: boolean;
  size?: number;
  onCancel: () => void;
  onOk: (values: any) => void;
  schema?: yup.ObjectSchema<any>;
  children: ReactNode;
  title: string;
  defaultValues?: any;
  form?: Pick<FormPropsType, "form">;
  isView?: boolean;
  onChange?: (values: any) => void;
} & Pick<FormProps, "labelCol" | "wrapperCol">) => {
  const footer = (
    <div className="absolute bottom-0 left-0 w-full bg-white py-6 px-6 border-t border-solid border-[#f0f0f0] z-10">
      <Flex gap="middle" justify="flex-end">
        <Button onClick={onCancel}>取消</Button>
        <ActionButtonSubmit onClick={onOk} />
      </Flex>
    </div>
  );

  return (
    <div className="relative h-full">
      <Drawer
        destroyOnHidden
        open={visible}
        onClose={onCancel}
        title={title}
        size={size}
        footer={null}
        className="h-full"
      >
        <Form
          schema={schema}
          defaultValues={defaultValues}
          form={form as any}
          isView={isView}
          onChange={onChange}
          {...formProps}
        >
          <div
            style={{
              height: isView ? "100%" : "calc(100% - 88px)",
              overflow: "auto",
              paddingBottom: isView ? "0" : "16px", // 预留错误提示空间
            }}
          >
            {children}
          </div>

          {!isView ? footer : null}
        </Form>
      </Drawer>
    </div>
  );
};
